import React from 'react';
import { classNames } from '@shapeable/utils';
import { Identity } from '../elements/identity';
import { IndicatorGroupLayoutDefault } from '../indicator-group-layouts';
import { useIndicatorGroupLayouts } from '../context/indicator-group-layouts-context';
import { indicatorHasValue } from '../utils/indicator-has-value';
var cls = classNames('indicator-groups-renderer');
export var IndicatorGroupsRendererDefaultProps = {
  itemRenderer: Identity
};
// -------- Components -------->
var My = {
  NAME: 'IndicatorGroupsRenderer'
};
export var IndicatorGroupsRenderer = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items;
  var ItemRenderer = props.itemRenderer;
  var indicatorGroupLayouts = useIndicatorGroupLayouts();
  var validItems = items.filter(function (item) {
    return item.indicators && item.indicators.length && item.indicators.some(indicatorHasValue);
  });
  if (!validItems.length) {
    return null;
  }
  return React.createElement(React.Fragment, null, validItems.map(function (item, index) {
    var _a;
    var GroupLayout = indicatorGroupLayouts[(_a = item.layout) === null || _a === void 0 ? void 0 : _a.component] || IndicatorGroupLayoutDefault;
    return React.createElement(ItemRenderer, {
      key: item.id
    }, React.createElement(GroupLayout, {
      key: item.id,
      entity: item
    }));
  }));
};
IndicatorGroupsRenderer.defaultProps = IndicatorGroupsRendererDefaultProps;
IndicatorGroupsRenderer.cls = cls;